import React from 'react';
import cx from 'classnames';
import {FieldValues} from 'react-hook-form';
import FormControl, {FormControlProps} from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import {makeStyles} from '@material-ui/core';
import CheckBox, {CheckBoxProps} from './CheckBox';
import {CheckBoxSkeleton} from '../../';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    header: {
        marginBottom: theme.spacing(2),
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        textTransform: 'unset'
    },
    formGroup: {
        '& label ~ label': {
            marginTop: theme.spacing(2)
        }
    },
    formLabel: {
        color: theme.palette.text.secondary,
        '& > span:last-child': {
            width: '100%'
        }
    }
}));

export interface CheckBoxGroup<FormValues extends FieldValues = FieldValues>
    extends Pick<FormControlProps, 'className' | 'required'> {
    header?: string | React.ReactNode | HTMLElement;
    options?: CheckBoxProps<FormValues>[];
    isRendering?: boolean;
}

function CheckBoxGroup<FormValues>({
    isRendering,
    header,
    options = [],
    children,
    className,
    ...props
}: React.PropsWithChildren<CheckBoxGroup<FormValues>>) {
    const styles = useStyles();

    return (
        <FormControl
            {...props}
            // error={invalid}
            className={cx(styles.root, className)}
            component="fieldset">
            <FormLabel className={styles.header} component="legend">
                {header}
            </FormLabel>
            <FormGroup className={styles.formGroup}>
                {options.map((option, index) => {
                    if (isRendering) {
                        return <CheckBoxSkeleton key={index} />;
                    }
                    return <CheckBox {...option} key={index} />;
                })}
                {children}
            </FormGroup>
        </FormControl>
    );
}

export default CheckBoxGroup;
